import React from "react";
import { chunk } from "lodash";
import clsx from "clsx";
import "./GuessScores.scss";

interface GuessScoresProps {
    scores: number[];
    score?: number;
    hideScore?: boolean;
    justifyPosition?: string;
}

const GuessScores: React.FC<GuessScoresProps> = (props) => {
    const chunkSize = 3;
    const rows = chunk(props.scores, chunkSize).map((chunkArr, chunkIndex) => {
        return chunkArr.map((score, index) => ({
            score,
            guessNumber: chunkIndex * chunkSize + index + 1,
        }));
    });
    const justifiedCenter = props?.justifyPosition === "justify-center";

    /**
     * Renders an array of element that displays guess score in order.
     */
    const renderScoresRow = (
        scores: Array<{ score: number; guessNumber: number }> = [],
        isFirstRow = false,
        isLastRow = false,
    ) => {
        return scores.map((item, i) => (
            <React.Fragment key={"score" + i}>
                {!isFirstRow && i === 0 && (
                    <div
                        className={clsx("indicator-line corner-line start", {
                            "short-line": isLastRow && justifiedCenter,
                        })}
                    ></div>
                )}
                <div className="guess-icon">
                    <div
                        className={clsx(
                            "guess-number",
                            { inactive: item.guessNumber > (props?.score ?? 0) },
                            "d-flex align-items-center justify-content-center",
                        )}
                    >
                        {item.guessNumber}
                    </div>

                    {props?.hideScore ? null : <span className="guess-score">{item.score}</span>}
                </div>
                {i + 1 !== scores.length ? (
                    <div className="indicator-line"></div>
                ) : (
                    !isLastRow && i === scores.length - 1 && <div className="indicator-line corner-line end"></div>
                )}
            </React.Fragment>
        ));
    };

    return (
        <>
            {rows.map((row, index) => (
                <div key={`scores-div-${index}`} className="d-flex justify-content-center my-4 position-relative">
                    <div className={clsx("guess-scores-container", props.justifyPosition)}>
                        {renderScoresRow(row, index === 0, index === rows.length - 1)}
                    </div>
                </div>
            ))}
        </>
    );
};

export default GuessScores;
